export default "__VITE_ASSET__BAoDNwoh__"